/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Adjust_Duration_Reading_SpeedInputs */

const en_shortcut_keys_desc_adjust_duration_reading_speed = /** @type {(inputs: Shortcut_Keys_Desc_Adjust_Duration_Reading_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatically update the duration of the Event based on the set reading speed (CPS) of the Event Group.`)
};

const fr_shortcut_keys_desc_adjust_duration_reading_speed = /** @type {(inputs: Shortcut_Keys_Desc_Adjust_Duration_Reading_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre a jour automatiquement la duree de l'evenement selon la vitesse de lecture (CPS) du groupe.`)
};

const de_shortcut_keys_desc_adjust_duration_reading_speed = /** @type {(inputs: Shortcut_Keys_Desc_Adjust_Duration_Reading_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Dauer des Ereignisses wird automatisch anhand der eingestellten Lesegeschwindigkeit (Zähler pro Sekunde, CPS) der Ereignisgruppe aktualisiert.`)
};

const it_shortcut_keys_desc_adjust_duration_reading_speed = /** @type {(inputs: Shortcut_Keys_Desc_Adjust_Duration_Reading_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna automaticamente la durata dell'evento in base alla velocità di lettura impostata (CPS) del gruppo di eventi.`)
};

const ru_shortcut_keys_desc_adjust_duration_reading_speed = /** @type {(inputs: Shortcut_Keys_Desc_Adjust_Duration_Reading_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматическое обновление продолжительности события в зависимости от установленной скорости чтения (CPS) группы событий.`)
};

const es_shortcut_keys_desc_adjust_duration_reading_speed = /** @type {(inputs: Shortcut_Keys_Desc_Adjust_Duration_Reading_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualice automáticamente la duración del evento en función de la velocidad de lectura establecida (CPS) del grupo de eventos.`)
};

const zh_cn2_shortcut_keys_desc_adjust_duration_reading_speed = /** @type {(inputs: Shortcut_Keys_Desc_Adjust_Duration_Reading_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`根据事件组的设定读取速度（CPS）自动更新事件的持续时间。`)
};

const ja_shortcut_keys_desc_adjust_duration_reading_speed = /** @type {(inputs: Shortcut_Keys_Desc_Adjust_Duration_Reading_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント グループに設定された読み取り速度 (CPS) に基づいて、イベントの継続時間を自動的に更新します。`)
};

const hi_shortcut_keys_desc_adjust_duration_reading_speed = /** @type {(inputs: Shortcut_Keys_Desc_Adjust_Duration_Reading_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट ग्रुप की निर्धारित पठन गति (सीपीएस) के आधार पर इवेंट की अवधि को स्वचालित रूप से अपडेट करें।`)
};

const pt_pt2_shortcut_keys_desc_adjust_duration_reading_speed = /** @type {(inputs: Shortcut_Keys_Desc_Adjust_Duration_Reading_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualize automaticamente a duração do evento com base na velocidade de leitura definida (CPS) do grupo de eventos.`)
};

/**
* | output |
* | --- |
* | "Automatically update the duration of the Event based on the set reading speed (CPS) of the Event Group." |
*
* @param {Shortcut_Keys_Desc_Adjust_Duration_Reading_SpeedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_adjust_duration_reading_speed = /** @type {((inputs?: Shortcut_Keys_Desc_Adjust_Duration_Reading_SpeedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Adjust_Duration_Reading_SpeedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_adjust_duration_reading_speed(inputs)
	if (locale === "de") return de_shortcut_keys_desc_adjust_duration_reading_speed(inputs)
	if (locale === "it") return it_shortcut_keys_desc_adjust_duration_reading_speed(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_adjust_duration_reading_speed(inputs)
	if (locale === "es") return es_shortcut_keys_desc_adjust_duration_reading_speed(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_adjust_duration_reading_speed(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_adjust_duration_reading_speed(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_adjust_duration_reading_speed(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_adjust_duration_reading_speed(inputs)
	return en_shortcut_keys_desc_adjust_duration_reading_speed(inputs)
});